// Splitting the task list into the three things it actually holds.
//
//   plan      standing work — done once, stays done
//   template  the master every-event checklist, never ticked
//   run       one event's copy of that template
//
// A run is open until every task in it is done. There is no Finish button:
// the last two items are filed within 48 hours of the event, so the run
// closing itself when they land is the same event as the work being finished.

import { leafTasksUnder, statusOf } from "../workplan/util";

export const kindOf = (node) => node.kind || "plan";

export function byKind(nodes) {
  const out = { plan: [], template: [], run: [] };
  for (const n of nodes || []) (out[kindOf(n)] || out.plan).push(n);
  return out;
}

export function runThemes(nodes) {
  return (nodes || []).filter((n) => kindOf(n) === "run" && n.level === "theme");
}

export function runProgress(nodes, themeId) {
  const tasks = leafTasksUnder(nodes, themeId);
  const done = tasks.filter((t) => statusOf(t) === "done").length;
  return { done, total: tasks.length, open: tasks.length === 0 || done < tasks.length };
}

// Newest first. `startedAt` is an ISO instant, so a string sort is a time sort.
const newestFirst = (a, b) => (b.startedAt || "").localeCompare(a.startedAt || "");

export function splitRuns(nodes) {
  const open = [];
  const closed = [];
  for (const theme of runThemes(nodes)) {
    (runProgress(nodes, theme.id).open ? open : closed).push(theme);
  }
  return { open: open.sort(newestFirst), closed: closed.sort(newestFirst) };
}

// Every node belonging to one run, so it can be handed to the tree builder on
// its own and render as a self-contained checklist.
export function nodesOfRun(nodes, themeId) {
  const keep = new Set([themeId]);
  let grew = true;
  while (grew) {
    grew = false;
    for (const n of nodes) {
      if (!keep.has(n.id) && keep.has(n.parentId)) { keep.add(n.id); grew = true; }
    }
  }
  return nodes.filter((n) => keep.has(n.id));
}

// "Sat 10 Sept, 7:42pm" — a run is identified by when it happened.
export function startedLabel(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined,
    { weekday: "short", day: "numeric", month: "short" });
}
